import { toast } from "react-toastify";
import PostApiCall from "../../Api/Api";
import GetApiCall from "../../Api/GetApi";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import Notiflix from "notiflix";

export class ProfileAction {
  static GetSeekerDetails() {
    return async (dispatch, getState) => {
      const { login } = await getState();
     
      Notiflix.Loading.standard();
      try {
        const res = await PostApiCall.postRequest(
          { id: login.fld_id },
          login.isAdmin === 1 || login.fld_usertype === "Staff"
            ? "GetStaffDetailsById"
            : "GetJobUserDetails"
        );

        const { data } = await res.json();
        dispatch({ type: "GET_SEEKER_DETAILS", payload: data });
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    };
  }
  static GetCountry() {
    return async (dispatch) => {
      try {
        const res = await GetApiCall.getRequest("GetCountry");
        const { data } = await res.json();

        dispatch({ type: "GET_COUNTRY", payload: data });
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    };
  }
  static GetState(id) {
    return async (dispatch) => {
      try {
        const res = await PostApiCall.postRequest(
          { countryid: id },
          "GetState"
        );
        const { data } = await res.json();

        dispatch({ type: "GET_STATE", payload: data });
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    };
  }
  static GetCity(id) {
    return async (dispatch) => {
      try {
        const res = await PostApiCall.postRequest({ stateid: id }, "GetCity");
        const { data } = await res.json();

        dispatch({ type: "GET_CITY", payload: data });
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    };
  }
}
